import { render, staticRenderFns } from "./InfoModal.vue?vue&type=template&id=6fcecd7a&scoped=true&"
import script from "./InfoModal.vue?vue&type=script&lang=js&"
export * from "./InfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fcecd7a",
  null
  
)

export default component.exports